import {
    VERIFY_MAIL,
    VERIFY_MAIL_SUCCESSFUL,
    VERIFY_MAIL_FAILED,
    VERIFY_ACCESS_TOKEN,
    VERIFY_ACCESS_TOKEN_FAILED,
    VERIFY_ACCESS_TOKEN_SUCCESS
  } from "./actionTypes"
  
  const initialState = {
    setVerifyEmailError: null,
    verifyEmailResponse:null,
    message: null,
    loading: false,
    user: null,
    setVerifyEmailErrorModule:null,
    verifyAccessTokenData:null,
    verifyAccessTokenError:null,
    loader: false
  }
  
  const verifymail = (state = initialState, action) => {
    switch (action.type) {
      case VERIFY_MAIL:
        state = {
          ...state,
          loading: true,
          loader: true,
          setVerifyEmailError: null,
          verifyEmailResponse:null,
          setVerifyEmailErrorModule:null
        }
        break
      case VERIFY_MAIL_SUCCESSFUL:
        state = {
          ...state,
          loading: false,
          loader: false,
          user: action.payload,
          verifyEmailResponse:action.payload,
          setVerifyEmailError: null,
          setVerifyEmailErrorModule:null
        }
        break
      case VERIFY_MAIL_FAILED:
       
        state = {
          ...state,
          user: null,
          loading: false,
          loader: false,
          verifyEmailResponse:null,
          setVerifyEmailError: action.payload[0],
          setVerifyEmailErrorModule:action.payload[1]
        }
        break
        case VERIFY_ACCESS_TOKEN:
        state = {
          ...state,
          loading: true,
          loader:true,
          verifyAccessTokenData: null,
          verifyAccessTokenError:null
        }
        break
      case VERIFY_ACCESS_TOKEN_SUCCESS:
        state = {
          ...state,
          loader: false,
          loading: false,
          verifyAccessTokenData: action.payload,
          verifyAccessTokenError: null
        }
        break
      case VERIFY_ACCESS_TOKEN_FAILED:
       
        state = {
          ...state,
          loading: false,
          loader: false,
          verifyAccessTokenData: null,
          verifyAccessTokenError: action.payload
        }
        break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default verifymail
  